import moment from "moment";
import "moment/locale/tr";

export default {
  computed: {
    getNowDate() {
      return moment().format("YYYY-MM-DD");
    },
    getFormatDate(val) {
      if (val) return moment(val).format("LL");
      else return i18n.t("noDate");
    },
    getDateFormat(val) {
      if (val) return moment(val).format("LL");
      else return i18n.t("noDate");
    },

    isMobile() {
      // let check = window.innerWidth<700;
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);

      return check;
    },



  },
  methods: {
    notificationAlert(message,position,timeout){
      const errorMessage = (message.response ? message.response.data.details?.body[0].message ? message.response.data.details.body[0].message  : message.response.data.message : message.message) || message

      this.$toast.warning(
        errorMessage, {
        position: position || "bottom-right",
        timeout: timeout || 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    },
    authController(error) {
      const errorMessage = error.response
        ? error.response.data.details?.body[0].message
          ? error.response.data.details.body[0].message
          : error.response.data.message
        : error.message;

      if (errorMessage) {
        this.$swal({
          title: i18n.t("commonMixins.sweetAlerts.warningAlert.title"),
          text: errorMessage,
          icon: "warning",
          confirmButtonText: i18n.t(
            "commonMixins.sweetAlerts.warningAlert.confirmButtonText"
          ),
        });
      } else {
        this.$swal({
          title: i18n.t("commonMixins.sweetAlerts.warningAlert.title"),
          text: error,
          icon: "warning",
          confirmButtonText: i18n.t(
            "commonMixins.sweetAlerts.warningAlert.confirmButtonText"
          ),
        });
      }
    },
    successMessage(message) {
      this.$swal({
        position: "center",
        icon: "success",
        title: i18n.t("commonMixins.sweetAlerts.successAlert.title"),
        text: message ? message : this.$t("message.success"),
        showConfirmButton: true,
        confirmButtonText: i18n.t(
          "commonMixins.sweetAlerts.successAlert.confirmButtonText"
        ),
        timer: 1000,
      });
    },
    warningMesage(message, timer) {
      return this.$swal({
        position: "center",
        icon: "warning",
        title: i18n.t("commonMixins.sweetAlerts.warningAlert.title"),
        text: message,
        showConfirmButton: true,
        confirmButtonText: i18n.t(
          "commonMixins.sweetAlerts.warningAlert.confirmButtonText"
        ),
        timer: timer ? timer : 1000,
      });
    },
    verifiedMessage(message, yesButon, noButon) {
      const verified = this.$swal({
        title: "UYARI!",
        text:  message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: yesButon
          ? yesButon
          : "Evet,eminim!",
        cancelButtonText: noButon
          ? noButon
          : 'Hayır,değilim',
      });
      return verified;
    },
    formatText(text) {
      try {
        return text
          .trim()
          .split(" ")
          .map((word) => {
            const wordLower = word.toLowerCase();
            const conjunctions = [
              "ve",
              "ya",
              "veya",
              "ancak",
              "ama",
              "fakat",
              "gibi",
              "ise",
              "ki",
              "ne",
              "veya",
              "veyahut",
              "de",
              "da",
              "ile",
              "ilelebet",
              "hani",
              "mademki",
              "eğer",
              "lakin",
              "ama",
              "meğer",
              "meğerki",
              "zira",
              "yahut",
              "yoksa",
              "oysa",
              "sanki",
              "hem",
              "ise",
              "de",
              "ya",
              "da",
              "ki",
              "ve/va",
              "ile",
              "ilelebet",
              "çünkü",
              "se",
              "çünkü ki",
              "rağmen",
              "hâlbuki",
              "lâkin",
              "ancak",
              "fakat",
              "oysa",
              "ise",
              "yahut",
              "veya",
              "kâh",
              "kî",
              "kuddise sirruh",
              "âhâ",
              "elbette",
              "elbetteki",
              "gerçi",
              "hâlbuki",
              "hattâ",
              "hele",
              "hem",
              "her ne kadar",
              "ki",
              "lâkin",
              "madem",
              "mademki",
              "meğer",
              "meğer ki",
              "ne",
              "neden",
              "oysa",
              "sanki",
              "ve",
              "velev ki",
              "veya",
              "veyahut",
              "yahut",
              "yoksa",
              "zira",
              // English conjunctions
              "and",
              "or",
              "but",
              "then",
              "because",
            ];

            const exceptions = ["/", "§", "€", "$", "£", "₺", "₿", "₽", "₹"];

            if (
              exceptions.includes(wordLower) ||
              /\b(ui|ux)\b/i.test(wordLower)
            ) {
              return word.replace(/\b(ui|ux)\b/gi, (match) =>
                match.toUpperCase()
              );
            } else if (conjunctions.includes(wordLower)) {
              return word;
            } else {
              return wordLower.charAt(0).toUpperCase() + wordLower.slice(1);
            }
          })
          .join(" ");
      } catch (err) {
        return text;
      }
    },

    listFormatController(val) {
      try {
        return JSON.parse(val);
      } catch (error) {
        if (Array.isArray(val)) return val;
        else {
          return [];
        }
      }
    },
    signOut() {
      this.axios.post(auth.signOut).then(() => {
        this.$store.commit("signOut");
        this.$router.push("/");
      });
    },

    formatDate(dateString) {
      // Regex pattern to match the specified date-time format
      const pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

      if (pattern.test(dateString)) {
        // If the string matches the pattern, format it as requested
        const date = new Date(dateString);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}`;
      } else {
        // If it doesn't match, return the original string
        return dateString;
      }
    },
    getDate(val) {
      if (val) return moment(this.formatDate(val)).format("LLL");
      else return "Tarih Yok";
    },
    isEmptyText(val){
      return val?.toString()?.replace(/\s/g, '')?.length==0;
    }
  },
  filters: {
    formatDate(val) {
      if (val) return moment(val).format("LLL");
      else return i18n.t("noDate");
    },
    formatDateYearMonth(val) {
      if (val) return moment(val).format("LL");
      else return i18n.t("noDate");
    },
  },
};